import { useCallback } from "react";

import dayjs from "@/lib/dayjs";
import { SalesMastType } from "@/lib/gql/__generated__/graphql";

import type { ViewData } from "../../../../model/type";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const downloadCSV = (csv: any, fileName: string) => {
	const blob = new Blob([csv], { type: "text/csv" });
	const link = document.createElement("a");
	link.href = window.URL.createObjectURL(blob);
	link.download = fileName;
	link.click();
};

const FORMAT_DATE_TEMPLATE = "YYYY-MM-DD";

export const useDownloadCSV = () => {
	/**
	 * 収支リストに関するCSVをダウンロードする
	 * WEB上でのダウンロードまでを担当している（サーバサイドだと実行できない）
	 *
	 * 基本的には旧管理画面（Nuxt v2）からコードをそのまま持ってきている
	 */
	const downloadSalesMastCSV = useCallback((rows: ViewData["searchResultTableData"]["rows"]) => {
		const headers = [
			"決済料金",
			"手数料",
			"合計収支",
			"カード認証日",
			"決済確定日",
			"購入項目",
			"予約ID/レシートID",
			"購入者名",
			"郵便番号",
			"住所",
			"Eメール",
			"電話番号",
			"カードブランド",
		] as const;

		const data = rows.map((receipt) => {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const csvArray: any[] = new Array<string>(headers.length - 1).map((_) => "");
			csvArray[headers.indexOf("決済料金")] = receipt.totalIncome;
			csvArray[headers.indexOf("手数料")] = receipt.commission ?? 0;
			csvArray[headers.indexOf("合計収支")] = receipt.income;
			csvArray[headers.indexOf("カード認証日")] = "N/A"; // 新管理画面（react）からは表示していないが、ExcelやNumbers で関数などを組んでいる場合があるので残している
			csvArray[headers.indexOf("決済確定日")] = dayjs(receipt.transferredAt).format(FORMAT_DATE_TEMPLATE);
			csvArray[headers.indexOf("購入項目")] = receipt.purchaseItemName;
			csvArray[headers.indexOf("予約ID/レシートID")] =
				receipt.salesMastType === SalesMastType.Ec
					? `'${receipt.userECReceiptID}'`
					: receipt.salesMastType === SalesMastType.ReservationCredit ||
						  receipt.salesMastType === SalesMastType.ReservationLocal
						? `'${receipt.reservationID}'`
						: "";
			csvArray[headers.indexOf("購入者名")] = receipt.buyerName;
			csvArray[headers.indexOf("郵便番号")] =
				"guestPostalCode" in receipt && Boolean(receipt.guestPostalCode) ? `'${receipt.guestPostalCode}'` : "";
			csvArray[headers.indexOf("住所")] = "guestAddress" in receipt ? receipt.guestAddress : "";
			csvArray[headers.indexOf("Eメール")] = "guestEmail" in receipt ? receipt.guestEmail : "";
			csvArray[headers.indexOf("電話番号")] = "guestTel" in receipt ? `'${receipt.guestTel}'` : "";
			csvArray[headers.indexOf("カードブランド")] = receipt.cardBrand || "";
			return csvArray.map((item) => `"${item}"`).join(",");
		});
		const header = `\ufeff${headers.join(",")}`;
		const csv = [header, ...data].join("\n");
		downloadCSV(csv, `CHILLNN_売上情報_${new Date().getTime()}.csv`);
	}, []);

	return {
		downloadSalesMastCSV,
	};
};
